import axios from './index'

const prefix = 'user'

export const read = params => {
  if (typeof params === 'object' || params === undefined) {
    return axios.get(prefix, { params })
  } else {
    return axios.get(`${prefix}/${params}`)
  }
}

export const create = payload => {
  return axios.post(prefix, payload)
}

export const update = payload => {
  return axios.put(prefix, payload)
}

export const del = id => {
  return axios.delete(`${prefix}/${id}`)
}

export const changePassword = payload => {
  return axios.post(`auth/change-password`, payload)
}

export const forgotPassword = payload => {
  return axios.post(`auth/forgot-password`, payload)
}
